import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import TablaEstandar from '../../tabla/TablaEstandar';

const renderCelda = (col, fila) => {
  if (col.id === 'actions') return fila.actions;
  if (col.id === 'firstUpdate')
    return new Date(fila.firstUpdate).toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  return fila[col.id];
};

const tituloTarjeta = (fila) =>
  `${fila.nombre || ''} ${fila.apellidos || ''}`.trim() || `#${fila.id}`;
const SIN_ON_LOAD_MORE = () => {};

const TablaResultados = ({
  data = null,
  searchMeta = null,
  tabla = null,
  onLoadMore = SIN_ON_LOAD_MORE,
  isLoadingMore = false,
  cargando = false,
  loadFacets = undefined,
  onExportar = null,
  isExporting = false,
  exportError = null,
}) => {
  const navigate = useNavigate();

  // `data` es el array de filas; null = aún no se ha buscado.
  if (data === null || !tabla) return null;

  const handleRowClick = (row) => {
    navigate(`/alumnos/${row.empresaId}/${row.id}/detalles`);
  };

  // Se exportan las columnas visibles, en su orden, sin la de Acciones.
  const exportar = () =>
    onExportar(tabla.columnasVisibles.filter((c) => !c.fixed).map((c) => c.id));

  return (
    <>
      {exportError && (
        <div role="alert" className="alert alert-danger" style={{ marginTop: '12px' }}>
          {exportError}
        </div>
      )}
      <TablaEstandar
        tabla={tabla}
        filas={data}
        total={searchMeta?.total ?? data.length}
        hayMas={searchMeta?.hasMore ?? false}
        cargandoMas={isLoadingMore}
        cargando={cargando}
        onCargarMas={onLoadMore}
        onFilaClick={handleRowClick}
        loadFacets={loadFacets}
        onExportar={onExportar ? exportar : null}
        exportando={isExporting}
        renderCelda={renderCelda}
        tituloTarjeta={tituloTarjeta}
        nombreEntidad="alumnos"
      />
    </>
  );
};

TablaResultados.propTypes = {
  data: PropTypes.array,
  searchMeta: PropTypes.shape({
    total: PropTypes.number,
    hasMore: PropTypes.bool,
  }),
  tabla: PropTypes.object,
  onLoadMore: PropTypes.func,
  isLoadingMore: PropTypes.bool,
  cargando: PropTypes.bool,
  loadFacets: PropTypes.func,
  onExportar: PropTypes.func,
  isExporting: PropTypes.bool,
  exportError: PropTypes.string,
};

export default TablaResultados;
